import { Grid, Typography, styled, Box, Button } from '@mui/material';
import { Colors, ColorsV2 } from 'app/constants/color';

const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  marginTop: '64px',
});

const TopHeadingGrid = styled(Grid)({
  margin: '20px 20px 7px 20px',
  display: 'flex',
  justifyContent: 'space-between',
});

const QuickArea = styled(Grid)({
  paddingLeft: '0 !important',
  height: '68vh !important',
});

const EventsArea = styled(Grid)({
  height: '1000px !important',
});

const NewsArea = styled(Grid)({
  height: '400px',
  paddingLeft: '0!important',
  overflow: 'scroll',
  border: `2px solid ${ColorsV2.outline}`,
  borderRadius: '10px',
  margin: '10px 0',
});

const NewsFeedGrid = styled(Grid)({
  height: '49vh',
  border: `2px solid ${ColorsV2.outline}`,
  boxShadow:
    '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
  borderRadius: '5px',
  paddingLeft: '0 !important',
  position: 'relative',
});

const CertFeedGrid = styled(Grid)({
  height: '30vh',
  border: `2px solid ${ColorsV2.outline}`,
  boxShadow:
    '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
  borderRadius: '5px',
  paddingLeft: '0 !important',
  position: 'relative',
});
const TwitterFeedArea = styled(Grid)({
  height: '400px',
  overflow: 'scroll',
  padding: '0!important',
  border: `2px solid ${Colors.outline}`,
  borderRadius: '10px',
  margin: '10px',
});

const HeadingContainer = styled(Box)({
  height: '105px',
  display: 'flex',
  alignItems: 'center',
});
const Title = styled(Typography)({
  fontFamily: 'Roboto, sans-serif',
  fontSize: '48px',
  lineHeight: '48px',
  fontWeight: '500',
});
const MessageArea = styled(Title)({
  boxSizing: 'border-box',
  border: `1px solid ${Colors.outline}`,
  borderRadius: '8px',
  color: 'rgba(0, 0, 0, 0.87)',
  fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
  fontWeight: 400,
  lineHeight: 1.43,
  letterSpacing: '0.01071em',
  outline: 'none',
  height: '100%',
  fontSize: '25px',
  padding: '100px 0',
  margin: '0 20px',
});
const CustomizedSettingButton = styled(Button)({
  backgroundColor: 'transparent',
  color: ColorsV2.white,
  lineHeight: '20px',
  fontWeight: '700',
  fontFamily: 'Lato, sans-serif',
  height: '42px',
  paddingInline: '0.5em',
  marginLeft: '10px',
  textTransform: 'none',
  gap: '0.4em',
  border: '1px solid white',
  display: 'flex',
  alignItems: 'center',
  ':hover': {
    backgroundColor: ColorsV2.acent,
  },
});

export {
  Container,
  TopHeadingGrid,
  HeadingContainer,
  Title,
  QuickArea,
  EventsArea,
  MessageArea,
  NewsArea,
  NewsFeedGrid,
  TwitterFeedArea,
  CustomizedSettingButton,
  CertFeedGrid,
};
